import Dica from '@/components/feature/Dica';

interface Props {
  titulo: string;
  aoVoltar: () => void;
  /** Dica "?" ao lado do título — o mesmo conteúdo de antes. */
  dicaId?: string;
  eventoId: number;
}

// Barra de cima das telas cheias: "← Voltar", título e o "?" de ajuda.
export default function TelaTitulo({ titulo, aoVoltar, dicaId, eventoId }: Props) {
  return (
    <div className="mb-3 flex items-center gap-2">
      <button
        type="button"
        onClick={aoVoltar}
        className="flex h-9 shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-full border border-background-200 bg-white px-3 text-[13px] font-semibold text-foreground-800 transition-colors hover:bg-background-100"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-line" aria-hidden />
        </span>
        Voltar
      </button>
      <h2 className="min-w-0 flex-1 truncate text-[15px] font-bold text-foreground-950">
        {titulo}
      </h2>
      {dicaId && <Dica id={dicaId} eventoId={eventoId} />}
    </div>
  );
}